import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import moment from 'moment-timezone'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import classnames from 'classnames'
import { getUser, getUser_v2 } from '../utils/dropdownlist'
import { MdDone, MdWarning, MdModeEdit } from 'react-icons/md'
import { FaEdit } from 'react-icons/fa'
import { IconContext } from 'react-icons/lib'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { CSVLink } from 'react-csv'

const headers = [
  {
    label: 'Store Code',
    key: 'store_code',
  },
  {
    label: 'Category',
    key: 'category',
  },
  {
    label: 'Product No.',
    key: 'product_no',
  },
  {
    label: 'Name',
    key: 'name',
  },
  {
    label: 'Quantity',
    key: 'qty',
  },
]

class StoreItemFulfilment extends React.Component {
  _isMounted = true
  storesalesDetail = StorageService.getSession('StoreItemFulfilment')
  constructor(props) {
    super(props)
    this.state = {
      redirect: false,
      isLoading: true,
      // fm_date:
      //   this.storesalesDetail && this.storesalesDetail.fm_date
      //     ? this.storesalesDetail.fm_date
      //     : moment()
      //         .subtract(1, 'days')
      //         .tz('Asia/Singapore')
      //         .format('YYYY-MM-DD'),
      // to_date:
      //   this.storesalesDetail && this.storesalesDetail.to_date
      //     ? this.storesalesDetail.to_date
      //     : moment()
      //         .subtract(1, 'days')
      //         .tz('Asia/Singapore')
      //         .format('YYYY-MM-DD'),
      fm_date: this.storesalesDetail && this.storesalesDetail.fm_date ? this.storesalesDetail.fm_date : moment().startOf('month').format('YYYY-MM-DD'),
      to_date: this.storesalesDetail && this.storesalesDetail.to_date ? this.storesalesDetail.to_date : moment().endOf('month').format('YYYY-MM-DD'),
      consolidate: this.storesalesDetail && this.storesalesDetail.consolidate ? this.storesalesDetail.consolidate : 0,
      salesList: [],
    }
  }

  componentDidMount() {
    if (this.storesalesDetail) {
      this.StoreSales()
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
    let data = this.storesalesDetail ? this.storesalesDetail : {}
    data[name] = value
    StorageService.setSession('StoreItemFulfilment', data)
    this.storesalesDetail = StorageService.getSession('StoreItemFulfilment')
  }

  StoreSales() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      fm_date: this.state.fm_date,
      to_date: this.state.to_date,
      consolidate: this.state.consolidate ? '1' : '0',
    }

    axios
      .post(url + ':3003/v1/order/report/schedule/stores', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            salesList: result.data,
          })
          if (result.data.length == 0) {
            this.notificationSystem.addNotification({
              title: <MdWarning />,
              message: 'Data Not Found',
              level: 'warning',
              position: 'br',
              autoDismiss: 4,
              dismissible: 'click',
            })
          }
        }
      })
      .catch(error => {
        console.log(error)
        alert(error)
      })
  }

  checkHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: !this.state[name],
    })
    let data = this.storesalesDetail ? this.storesalesDetail : {}
    data[name] = value
    StorageService.setSession('StoreItemFulfilment', data)
    this.storesalesDetail = StorageService.getSession('StoreItemFulfilment')
  }

  CsvNotFound() {
    this.notificationSystem.addNotification({
      title: <MdWarning />,
      message: 'Data Not Found',
      level: 'warning',
      position: 'br',
      autoDismiss: 4,
      dismissible: 'click',
    })
  }

  render() {
    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <Row>
          <Col>
            <h5>
              Store Item Fulfilment Report <br />
              (Based on Orders Fulfillment Date)
            </h5>
          </Col>
        </Row>
        <Row>
          <Col md={2}>
            <Label>Fulfilment Date</Label>
            <Input className="ps-input-small" type="date" name="fm_date" onChange={this.changeHandler} value={this.state.fm_date} />
          </Col>
          <Col md={1}>
            <Label></Label>
            <p
              style={{
                padding: '0.4rem',
                textAlign: 'center',
                whiteSpace: 'nowrap',
              }}>
              To
            </p>
          </Col>
          <Col md={2}>
            <Label>Fulfilment Date</Label>
            <Input className="ps-input-small" type="date" name="to_date" onChange={this.changeHandler} value={this.state.to_date} />
          </Col>
          <Col md={2} style={{ margin: 'auto' }}>
            <Label></Label>
            <FormGroup check>
              <Label check>
                <Input type="checkbox" name="consolidate" checked={this.state.consolidate} onChange={this.checkHandler} />
                Consolidate
              </Label>
            </FormGroup>
          </Col>
          <Col md={2} className="ps-margin-auto-desktop">
            <Button className="ps-input-small" onClick={() => this.StoreSales()}>
              Search
            </Button>
          </Col>
          <Col></Col>
        </Row>

        <Row>
          <Col>
            <CSVLink
              data={this.state.salesList}
              headers={headers}
              filename={'StoreItemFulfilmentReport_' + moment(this.state.fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'}
              onClick={() => {
                if (this.state.salesList.length < 1) {
                  this.CsvNotFound()
                  return false
                }
              }}>
              <Button type="button" className="ps-input-small theme-button-primary">
                Export
              </Button>
            </CSVLink>
          </Col>
        </Row>

        <Row>
          <Col>
            <Table className="ps-table tb-col-7 ps-responsive-table">
              <Thead>
                <Tr>
                  <Th>Store Code</Th>
                  <Th>Category</Th>
                  <Th>Product No.</Th>
                  <Th>Name</Th>
                  <Th>Quantity</Th>
                </Tr>
              </Thead>
              <Tbody>
                {this.state.salesList.length > 0 &&
                  this.state.salesList.map((item, index) => {
                    return (
                      <Tr key={index}>
                        <Td>{item.store_code}</Td>
                        <Td>{item.category}</Td>
                        <Td>{item.product_no}</Td>
                        <Td>{item.name}</Td>
                        <Td>{item.qty}</Td>
                      </Tr>
                    )
                  })}
              </Tbody>
            </Table>
          </Col>
        </Row>
      </>
    )
  }
}

export default StoreItemFulfilment
